const cityTypes = ["город", "city", "місто", "kasaba", "şəhər"];

export default (settlementType, settlement) => {
	const type = settlementType || "";
	let cityValue = "";
	if (cityTypes.includes(settlementType)) {
		cityValue = settlement;
	} else if (type) {
		cityValue = `${type} ${settlement}`;
	} else {
		cityValue = settlement;
	}
	return cityValue;
};
